import { DataSignal } from 's-js';
import UOM from 'lib/UOM';

export const uomIsFeet = (uom : DataSignal<string>) => ((val? : boolean) => {
    if (val === undefined) return uom() === UOM.Foot;
    uom(val ? UOM.Foot : UOM.Meter);
    return val;
}) as DataSignal<boolean>;


// WEBPACK FOOTER //
// ./apps/common/services/uomIsFeet.ts